import React, { useEffect, useRef, useState } from 'react';
import SpeechRecognition, { useSpeechRecognition } from 'react-speech-recognition';
import { Mic, MicOff } from 'lucide-react';

let activeMicId = null;

const SpeechRecognitionComponent = ({ onTranscript, onResetTranscript, onStartListening, iconSize = 24 }) => {
  const {
    transcript,
    listening,
    resetTranscript,
    browserSupportsSpeechRecognition
  } = useSpeechRecognition();

  const idRef = useRef(Math.random().toString(36).substring(2, 10));
  const isActive = listening && activeMicId === idRef.current;

  if (!browserSupportsSpeechRecognition) {
    return null;
  }

  useEffect(() => {
    if (isActive && onTranscript) {
      onTranscript(transcript);
    }
  }, [transcript, isActive, onTranscript]);

  useEffect(() => {
    if (onResetTranscript) {
      onResetTranscript(() => {
        if (activeMicId === idRef.current) {
          SpeechRecognition.stopListening();
          activeMicId = null;
        }
        resetTranscript();
        if (onTranscript) {
          onTranscript('');
        }
      });
    }
  }, [onResetTranscript, onTranscript, resetTranscript]);

  const handleStart = () => {
    if (activeMicId && activeMicId !== idRef.current) {
      SpeechRecognition.stopListening();
      activeMicId = null;
      setTimeout(() => {
        activeMicId = idRef.current;
        resetTranscript();
        if (onStartListening) onStartListening();
        SpeechRecognition.startListening({ continuous: true });
      }, 200);
    } else {
      activeMicId = idRef.current;
      resetTranscript();
      if (onStartListening) onStartListening();
      SpeechRecognition.startListening({ continuous: true });
    }
  };

  const handleStop = () => {
    SpeechRecognition.stopListening();
    if (activeMicId === idRef.current) {
      activeMicId = null;
    }
    resetTranscript();
    if (onTranscript) {
      onTranscript('');
    }
  };

  const iconProps = { cursor: 'pointer', width: `${iconSize}px`, height: `${iconSize}px`, color: isActive ? 'red' : 'black' };

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      {isActive ? (
        <MicOff onClick={handleStop} style={iconProps} />
      ) : (
        <Mic onClick={handleStart} style={iconProps} />
      )}
    </div>
  );
};

export default SpeechRecognitionComponent; 